import { Loader2 } from "lucide-react";
import type React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface SendingBadgeProps {
  className?: string;
}

export const SendingBadge: React.FC<SendingBadgeProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <output
      aria-live="polite"
      className={cn(
        "inline-flex items-center gap-1 text-xs text-blue-500",
        className,
      )}
    >
      <Loader2 aria-hidden="true" className="size-3 animate-spin" />
      {t("common.sending")}
    </output>
  );
};
